import React, { useEffect, useState } from 'react'
import axiosInstance from '../../utils/axiosUtil';

function ApprovalButton({value,status,id,disable}) {
 const [disabled,setDisabled] = useState(false)
  useEffect(()=>{
    if(disable && status === 'Approved'){
      setDisabled(true)
    } else if (!disable && status === 'Rejected'){
      setDisabled(true)
    }
  },[])
  
   async function handleClick() {
     try {
      if (disabled) return;
         const {data} = await axiosInstance.put(`/admin/update_quotation_status/${id}`,{status})
         console.log(data,'function cliocked');
         window.location.reload()
     } catch (error) {
         console.log(error,'error');
     }
   }  
  return (
    <div className={`hover:cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
    <div
        className="px-2 py-1 rounded cursor-pointer"
        style={{
            backgroundColor: value === "Approve" ? "green" : "red",
            cursor: disabled ? "not-allowed" : "pointer",
            color: "white",
            pointerEvents: disabled ? "none" : "auto",
        }}
        onClick={handleClick}
    >
        {value}
    </div>
</div>
  )
}

export default ApprovalButton